module.exports = __webpack_public_path__ + "static/ch5-SCENE-06-MLK_Asks_LBJ_For_Support-920aaaa370fe13508371c6d22ea45ed6.mp4";